import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'

const IconWrapper = styled.span`
  color: ${cssTheme.colors.content.danger.secondary};
  margin-right: ${cssTheme.layout.spacing.s200};
  margin-top: ${cssTheme.layout.spacing.s100};
  align-self: flex-start;
`

const UnavailabilityContentElement = styled.div`
  ${cssTheme.typography.bodyS};
`

const UnavailabilityMessageWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: ${cssTheme.layout.spacing.s300};
`

/** Shared layout may be reused with alternative messages / CTAs */
export const SoldOutBase = ({
  headerSlot,
  contentSlot,
  actionSlot
}: {
  headerSlot: React.ReactNode
  contentSlot: React.ReactNode
  actionSlot?: React.ReactNode
}) => (
  <UnavailabilityMessageWrapper data-id="SoldOutBase">
    <Box display="flex" alignItems="center">
      <IconWrapper>
        <Icon size="md" name="Forbid" />
      </IconWrapper>
      <Text variant="titleM">{headerSlot}</Text>
    </Box>
    {!!contentSlot && (
      <UnavailabilityContentElement>{contentSlot}</UnavailabilityContentElement>
    )}
    {!!actionSlot && actionSlot}
  </UnavailabilityMessageWrapper>
)
